import template from "./pAdminRates.html";

export function pAdminRatesDirective() {
  'ngInject';

  let directive = {
    restrict: 'E',
    template: template,
    controller: pAdminRatesController,
    controllerAs: 'pAdminRates',
    bindToController: true
  };

  return directive;
}

class pAdminRatesController {
  constructor(Auth, Admin, $q, Controlling, $scope, $interval, Notes, ConnectionQuality, $translate) {
    'ngInject';

    this.Auth = Auth;
    this.Admin = Admin;
    this.$q = $q;
    this.Controlling = Controlling;
    this.$scope = $scope;
    this.$interval = $interval;
    this.Notes = Notes;
    this.ConnectionQuality = ConnectionQuality;
    this.$translate = $translate;

    this.init();

    this.fields = {
      country: "info",
      profitCenterName: "info",
      seniorityLevelName: "info",
      rate: "info",
      validFrom: "info"
    };

    $scope.$on('connectionQualityChanged', () => {
      if (this.ConnectionQuality.isSlow) {
        this.Notes.postNote({
          type: 'slowConnection',
          manualHide: true
        });
      }
      else {
        const note = this.Notes.getNotes().find(note => note.type === 'slowConnection' && note.active);
        if (note)
          this.Notes.hide(note);
      }
    });

    this.LEVELS_DICTIONARY = {};
  }

  init() {
    this.state = 'loading';
    this.Auth.authorizeAdmin().then(
      (user) => {
        this.user = user;
        let promises = [this.Admin.getRates(), this.Admin.getProfitCenters()];
        this.$q.all(promises).then(
          (success) => {
            this.rates = success[0].data.rates;
            this.profitCenters = success[1].data;
            this.rates.forEach(r => {
              this.profitCenters.find(s => {
                if (s.id == r.profitCenterId) {
                  r.country = s.country;
                  r.profitCenterName = `${s.code} - ${s.name}`;
                }

                if (!this.LEVELS_DICTIONARY[r.seniorityLevel]) {
                  this.LEVELS_DICTIONARY[r.seniorityLevel] = this.$translate.instant(`USER.${r.seniorityLevel}`);
                }

                r.seniorityLevelName = this.LEVELS_DICTIONARY[r.seniorityLevel];
              });
            });
            // this.rates = this.sortRates(this.rates);
            this.state = "loaded";
          },
          (error) => {
            this.state = "error";
            this.Notes.postNote({type: "error", error: error});
          }
        );
        var timeout = this.$interval(() => {
          this.notes = this.Notes.getNotes();
        }, 10);
        this.$scope.$on("$destroy", () => {this.$interval.cancel( timeout);});
      },
      () => {
        this.Auth.handleUnauthorized();
      }
    );
  }

  sortRates(rates) {
    var finalRates = [];

    var levels = ["Junior", "Regular", "Senior", "MiddleManager", "TopManager"];

    finalRates.sort(function(a, b) {
      return new Date(a.validFrom) - new Date(b.validFrom);
    });
    for(var i in levels) {
      finalRates = finalRates.concat(rates.filter(r => r.seniorityLevel == levels[i]));
    }

    var tempRates = [];
    var profitCentersName = [];
    this.profitCenters.forEach(s => profitCentersName.push(s.name));
    profitCentersName = profitCentersName.sort();
    profitCentersName.forEach(s => {
      tempRates = tempRates.concat(finalRates.filter(r => r.profitCenterName == s));
    });

    var countries = [];

    for (var j in this.profitCenters) {
      if (countries.length == 0) {
        countries = countries.concat(this.profitCenters[j].country);
      }
      else if (!countries.find(c => c == this.profitCenters[j].country)) {
        countries = countries.concat(this.profitCenters[j].country);
      }
    }
    countries.sort();

    var tempRatesByCountry = [];

    countries.forEach(c => {
      tempRatesByCountry = tempRatesByCountry.concat(tempRates.filter(r => {
        if (r.country == c)
          return r;
      }));
    });

    return tempRatesByCountry;
  }
}
